import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWaterpomptang1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#waterpomptang_1_svg__a)">
      <path
        fill="#B3E9B1"
        d="m31.94 14.47-3.16 1a.5.5 0 0 1-.44-.08l-2.68-1.93a2.2 2.2 0 0 0-.94-.39l-9.79-1.6a2.78 2.78 0 0 0-2.11.49l-28.47 20.46 3.41 4.73 26.5-19a2.83 2.83 0 0 1 2.11-.49l12.26 2a5.84 5.84 0 0 0 6.55-4.13.62.62 0 0 0-.49-.79L33 14.4a2.3 2.3 0 0 0-1.06.07"
      />
      <path
        fill="#60D15D"
        d="M28 5h-3.31a7.06 7.06 0 0 0-7.06 7.05v11.38a7.38 7.38 0 0 1-2.17 5.23l-30.2 30.21 4.13 4.13L21.3 31.08a7.4 7.4 0 0 0 2.17-5.23v-13.8h.79c.347.003.69-.076 1-.23l3-1.47a.45.45 0 0 1 .45 0l3 1.47c.31.154.653.233 1 .23h1.7a.69.69 0 0 0 .68-.77A7.06 7.06 0 0 0 28 5m-6 18.5a1.46 1.46 0 0 1-1.45 1.5 1.46 1.46 0 0 1-1.46-1.46v-8a1.46 1.46 0 0 1 1.46-1.46A1.46 1.46 0 0 1 22 15.52z"
      />
      <path
        fill="#00215B"
        fillRule="evenodd"
        d="M21.288 15.116a1.279 1.279 0 1 0 .417 1.761l.85.526a2.28 2.28 0 1 1-.742-3.138z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="waterpomptang_1_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWaterpomptang1);

export default ForwardRef;
